export const UPDATE_APPLICATION = 'UPDATE_APPLICATION'
export const SET_MODE = 'SET_MODE'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_VCASH_PRICE = 'SET_VCASH_PRICE'
